'use strict';

const asn1 = require('asn1.js');

/**
 * RFC5280 X509 and Extension Definitions
 */

const rfc5280 = exports;

// AlgorithmIdentifier  ::=  SEQUENCE  {
//      algorithm               OBJECT IDENTIFIER,
//      parameters              ANY DEFINED BY algorithm OPTIONAL  }
const AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('subAlgorithm').optional()
      .objid(),
    this.key('parameters').optional()
      .any(),
  );
});
rfc5280.AlgorithmIdentifier = AlgorithmIdentifier;

// CertificationRequest ::= SEQUENCE {\n\
//   certificationRequestInfo CertificationRequestInfo,\n\
//   signatureAlgorithm AlgorithmIdentifier,\n\
//   signature          BIT STRING\n\
// }
const CertificationRequestInfo = asn1.define('CertificationRequestInfo', function () {
  this.seq().obj(
    this.key('version').use(Version),
    this.key('subject').use(Name),
    this.key('subjectPKInfo').use(SubjectPublicKeyInfo),
    this.key('attributes').explicit(0)
      .use(Attribute),
  );
});
rfc5280.CertificationRequestInfo = CertificationRequestInfo;

// CertificationRequest ::= SEQUENCE {\n\
//   certificationRequestInfo SM2-Double-CertificationRequestInfo,\n\
//   signatureAlgorithm AlgorithmIdentifier,\n\
//   signature          BIT STRING\n\
// }
const CertificationRequest = asn1.define('CertificationRequest', function () {
  this.seq().obj(
    this.key('certificationRequestInfo').use(CertificationRequestInfo),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signature').bitstr(),
  );
});

rfc5280.CertificationRequest = CertificationRequest;

// Version  ::=  INTEGER  {  v1(0), v2(1), v3(2)  }
const Version = asn1.define('Version', function () {
  this.int({
    0: 'v1',
    1: 'v2',
    2: 'v3',
  });
});
rfc5280.Version = Version;

// SubjectPublicKeyInfo  ::=  SEQUENCE  {
//      algorithm            AlgorithmIdentifier,
//      subjectPublicKey     BIT STRING  }
const SubjectPublicKeyInfo = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr(),
  );
});
rfc5280.SubjectPublicKeyInfo = SubjectPublicKeyInfo;

// Name ::= CHOICE { -- only one possibility for now --
//      rdnSequence  RDNSequence }
const Name = asn1.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence),
  });
});
rfc5280.Name = Name;

// RDNSequence ::= SEQUENCE OF RelativeDistinguishedName
const RDNSequence = asn1.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName);
});
rfc5280.RDNSequence = RDNSequence;

// RelativeDistinguishedName ::=
//      SET SIZE (1..MAX) OF AttributeTypeAndValue
const RelativeDistinguishedName = asn1.define(
  'RelativeDistinguishedName',
  function () {
    this.setof(AttributeTypeAndValue);
  },
);
rfc5280.RelativeDistinguishedName = RelativeDistinguishedName;

// AttributeTypeAndValue ::= SEQUENCE {
//      type     AttributeType,
//      value    AttributeValue }
const AttributeTypeAndValue = asn1.define('AttributeTypeAndValue', function () {
  this.seq().obj(
    this.key('type').use(AttributeType),
    this.key('value').use(AttributeValue),
  );
});
rfc5280.AttributeTypeAndValue = AttributeTypeAndValue;

// Attribute               ::= SEQUENCE {
//       type             AttributeType,
//       values    SET OF AttributeValue }
const Attribute = asn1.define('Attribute', function () {
  this.seq().obj(
    this.key('type').use(AttributeType),
    this.key('values').setof(AttributeValue),
  );
});


// AttributeType ::= OBJECT IDENTIFIER
const AttributeType = asn1.define('AttributeType', function () {
  this.objid();
});
rfc5280.AttributeType = AttributeType;

// AttributeValue ::= ANY -- DEFINED BY AttributeType
const AttributeValue = asn1.define('AttributeValue', function () {
  this.choice({
    teletexString: this.t61str(),
    printableString: this.printstr(),
    universalString: this.unistr(),
    utf8String: this.utf8str(),
    bmpString: this.bmpstr(),
    ia5String: this.ia5str(),
  });
});
rfc5280.AttributeValue = AttributeValue;
